import gql from 'graphql-tag'

const CREATE_INTEGRATION = gql`
  mutation CreateIntegration($partnerName: PartnerName!) {
    createIntegration(partnerName: $partnerName)
  }
`
const REMOVE_INTEGRATION = gql`
  mutation RemoveIntegration($partnerName: PartnerName!) {
    removeIntegration(partnerName: $partnerName)
  }
`

export { CREATE_INTEGRATION, REMOVE_INTEGRATION }
